import Nav from '../components/Nav'
import UploadFile from '../components/UploadFile'
import {useEffect} from 'react'
import {useParams} from 'react-router-dom'
import axios from 'axios'
import FormHandler from '../hooks/FormHandler';
import config from '../config';
import upload_pic from '../img/icon/image-upload-fill.png';
import {useCookies} from 'react-cookie'
import { reverseSizeMap } from '../utils/sizeUtils';

const AddItem = () => {
    const [cookies] = useCookies(null)
    const { id } = useParams();

    const {  formData, setFormData, handleChange, handleFileChange, handleSubmit, getLocations } = FormHandler({
        ownerId: cookies.UserId,
        clothing_cut: "female",
        clothing_type: "shoe",
        size: 0,
        pic: "",
        description: "",
        plz: "",
        coordinateX: 0,
        coordinateY: 0,
        price: 0
    }, id, "item")

    const getCurrentClothingPiece = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}clothingpieces`, {
                headers: {"token": localStorage.getItem("token")},
                params: {id: id}
            })
            const clothing_cut = response.data["clothing_cut"]
            const numeric_size = response.data["size"]

            const clothing_size = response.data["clothing_type"] === 'shoe' || response.data["clothing_type"] === 'trousers'  ? numeric_size : reverseSizeMap[clothing_cut][numeric_size]

            setFormData((prevState) => ({
                ...prevState,
                ["size"]: clothing_size,
                ["clothing_type"]: response.data["clothing_type"],
                ["clothing_cut"]: clothing_cut,
                ["description"]: response.data["description"],
                ["pic"]: response.data["url"],
                ["plz"]: response.data["plz"],
                ["price"]: response.data["price"]

            }));
            
        } catch (error) {
            console.log(error)
        }
    }

    const getUser = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}user`,{
                headers: {"token": localStorage.getItem("token")},
                params: {userId: cookies.UserId}
            })

            setFormData((prevState) => ({
                ...prevState,
                ["plz"]: response.data["plz"]
            }))
            const response_coor = await axios.get(`${config.apiUrl}location`,
                {   headers: {"token": localStorage.getItem("token")},
                    params: {plz:response.data["plz"]}}
            )
            const coordinates = response_coor.data
            
            const array_of_coords = coordinates.split(";")
            if ((typeof coordinates === 'string' || coordinates instanceof String)&&array_of_coords.length === 2){
                const longitude = parseFloat(array_of_coords[0])
                const latitude = parseFloat(array_of_coords[1])
                setFormData((prevState) => ({
                ...prevState,
                ["coordinateX"]: longitude,
                ["coordinateY"]: latitude
                }))
            }
            
        }
        catch (error){
            console.log(error)
        }

    }

    useEffect(() => {
        getUser();
        if (id !== '0'){
            getCurrentClothingPiece();
        }
        getLocations();
    }, []);

    return (
        <>
            <div className="additem">
                <h2>{id && id !== "0" ? "Kleidungsstück bearbeiten" :"Kleidungsstück hinzufügen"}</h2>

                <form onSubmit={handleSubmit}>
                    <section>


                        <label>Schnitt</label>
                        <div className="multiple-input-container">
                            <input
                                id="female-clothing-cut"
                                type="radio"
                                name="clothing_cut"
                                value="female"
                                onChange={handleChange}
                                checked={formData.clothing_cut === "female"}
                            />
                            <label htmlFor="female-clothing-cut">Frau</label>
                            <input
                                id="male-clothing-cut"
                                type="radio"
                                name="clothing_cut"
                                value="male"
                                onChange={handleChange}
                                checked={formData.clothing_cut === "male"}
                            />
                            <label htmlFor="male-clothing-cut">Mann</label>
                            <input
                                id="unisex-clothing-cut"
                                type="radio"
                                name="clothing_cut"
                                value="unisex"
                                onChange={handleChange}
                                checked={formData.clothing_cut === "unisex"}
                            />
                            <label htmlFor="unisex-clothing-cut">Unisex</label>
                            <input
                                id="kid-clothing-cut"
                                type="radio"
                                name="clothing_cut"
                                value="kid"
                                onChange={handleChange}
                                checked={formData.clothing_cut === "kid"}
                            />
                            <label htmlFor="kid-clothing-cut">Kind</label>
                        </div>


                        <label htmlFor="description">Beschreibung</label>
                        <input
                            id="description"
                            type="text"
                            name="description"
                            required={true}
                            placeholder="Das Kleidungsstück ist sehr alt, aber..."
                            value={formData.description}
                            onChange={handleChange}
                        />

                            <label>Kleidungstyp</label>
                            <div className="multiple-input-container">
                                <input
                                    id="shoe-clothing-type"
                                    type="radio"
                                    name="clothing_type"
                                    value="shoe"
                                    onChange={handleChange}
                                    checked={formData.clothing_type === "shoe"}
                                    required
                                />
                                <label htmlFor="shoe-clothing-type">Schuhe</label>
                                <input
                                    id="trousers-clothing-type"
                                    type="radio"
                                    name="clothing_type"
                                    value="trousers"
                                    onChange={handleChange}
                                    checked={formData.clothing_type === "trousers"}
                                    required
                                />
                                <label htmlFor="trousers-clothing-type">Hosen</label>
                                <input
                                    id="top-clothing-type"
                                    type="radio"
                                    name="clothing_type"
                                    value="top"
                                    onChange={handleChange}
                                    checked={formData.clothing_type === "top"}
                                    required
                                />
                                <label htmlFor="top-clothing-type">Top</label>

                                <input
                                    id="accessoire-clothing-type"
                                    type="radio"
                                    name="clothing_type"
                                    value="accessoire"
                                    onChange={handleChange}
                                    checked={formData.clothing_type === "accessoire"}
                                    required
                                />
                                <label htmlFor="accessoire-clothing-type">Accessoire</label>
                            </div>


                        <input type="submit"/>
                    </section>
                    <section>
                    <label htmlFor="size">Grösse</label>

                    {formData.clothing_type === 'accessoire' || formData.clothing_type === 'top' ? (
                        <select
                            id="size"
                            name="size"
                            value={formData.size}
                            onChange={handleChange}
                        >
                            <option value="">Keine</option>
                            <option value="XXS">XXS</option>
                            <option value="XS">XS</option>
                            <option value="S">S</option>
                            <option value="M">M</option>
                            <option value="L">L</option>
                            <option value="XL">XL</option>
                            <option value="XXL">XXL</option>
                            <option value="XXXL">XXXL</option>
                        </select>
                    ) : (
                        <input
                            id="size"
                            type="number"
                            name="size"
                            min="24"
                            max="92"
                            default="0"
                            step={0.5}
                            value={formData.size}
                            onChange={handleChange}
                            required
                        />
                    )}

                    <label htmlFor="plz">Abholort (Postleitzahl)</label>

                    <input
                        id="plz"
                        type="number"
                        name="plz"
                        min="0"
                        value={formData.plz}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="price">Preis</label>

                    <input
                        id="price"
                        type="number"
                        name="price"
                        min="0"
                        max="500"
                        value={formData.price}
                        onChange={handleChange}
                        step="0.05"
                        required
                    />

                    <UploadFile
                        title={"Bild"}
                        file={formData.pic}
                        filetype={"user"}
                        handleFileChange={handleFileChange}
                    />

                    </section>

                </form>
            </div>
        </>
    )
}
export default AddItem